/**
 * This directive is used to show filter dynamically based on scroll position on product view detail dialog.
 * It would be nice if this was much more general so it could be used in other places as well. But yeah, you know, time...
 */
angular.module('impactx.productview').directive("ixProductViewFilter", function() {
    return function(scope, element) {
        element.bind("scroll", function() {
            scope.visible = angular.element('#productViewProducts').offset().top - 100 <= angular.element('#productViewContainer').height() / 2;
            scope.$apply();
        });
    };
});